<template>
    <div class="smr-slider">
        <div class="smr-slider__top ui-spread">
            <div class="smr-slider__label caption black" :class="labelClass || ''">{{ label }}</div>
            <div class="smr-slider__value copy-bold black">{{ formattedValue }}</div>
        </div>
        <el-slider
            v-model="data"
            :min="min"
            :max="max"
            :show-tooltip="false"
            :step="step"
            :show-stops="true"
            :range="range"
            @change="changeHandler"
        >
        </el-slider>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [Number, Array],
            default: 0
        },
        options: {
            type: Array,
            default: () => []
        },
        range: {
            type: Boolean,
            default: false
        },
        rangeValueTemplate: {
            type: [Boolean, String],
            default: false
        },
        labelClass: {
            type: [Boolean, String],
            default: false
        }
    },
    data() {
        return {
            data: 0,
            min: 0,
            max: 10,
            step: 1
        }
    },
    computed: {
        hasCustomOptions() {
            return this.options.length > 0
        },
        formattedValue() {
            if(this.range) {
                if(this.rangeValueTemplate && this.data.length >= 2) {
                    let newLabel = this.rangeValueTemplate
                    this.data.forEach((v, index) => {
                        newLabel = newLabel.replace(`%{${index}}`, this.options[v].label)
                    })
                    return newLabel
                }
                return ''
            }
            if(this.hasCustomOptions) {
                return `${this.options[this.data].label}`
            }
            return `${this.data}`
        }
    },
    mounted() {
        this.prepareOptions()
        this.setInitialValue()
    },
    methods: {
        changeHandler() {
            this.emitChange()
        },
        setInitialValue() {
            if(this.value) {
                if(this.hasCustomOptions) {
                    if(this.range) {
                        this.data = []
                        this.value.forEach(val => {
                            this.data.push(this.options.findIndex(item => item.value === val))
                        })
                    } else {
                        this.data = this.options.findIndex(item => item.value === this.value)
                    }
                } else {
                    this.data = this.value
                }
            }
        },
        prepareOptions() {
            if(this.hasCustomOptions) {
                this.max = this.options.length - 1
            }
        },
        getOptionsValue() {
            if(this.range) {
                let values = []
                this.data.forEach(dataValue => {
                    values.push(this.options[dataValue].value)
                })
                return values
            }
            return this.options[this.data].value
        },
        emitChange() {
            let dataToEmit = this.data
            if(this.hasCustomOptions) {
                dataToEmit = this.getOptionsValue()
            }
            this.$emit('change', dataToEmit);
        },
    }
}
</script>

<style lang="scss">
.smr-slider {
    max-width: calc(100% - 2px); // avoid horizontal scroll on mobile
    &__label {
        margin-bottom: 0 !important;
    }
    .el-slider {
        &__runway {
            height: 8px;
            border-radius: 4px;
        }
        &__bar {
            height: 8px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            background-color: $color-yellow;
        }
        &__button {
            width: 24px;
            height: 24px;
            border: none;
            background: $color-yellow;
            box-shadow: $elevation-shadow;
            transform: none !important;
        }
        &__stop {
           height: 8px;
           width: 8px;

           &.el-slider__marks-stop {
               &:first-child,
               &:last-child {
                   opacity: 0;
               }
           }
        }
    }
}
</style>